import { useCallback, useEffect, type VFC } from 'react'
import * as legacyNav from '@panwds/react-nav'
import * as sparkyNav from '@panwds/sparky-react-nav'
import defaultLogo from '../../images/SCM-Logo.svg'
import defaultCollapsedLogo from '../../images/SCM-Collapsed-Logo.svg'
import TopNavigation from './TopNav'
import BottomNavigation from './BottomNav'
import { stateRef } from '../../framework/store'
import { setValuesInternal } from '../../framework/actions'
import { getRootElement } from './fawkesUtils'
import './LeftNav.scss'
import type { StoreState, OidcState, Vars } from '../../framework/stateTypes'
import type { NavItem as NavItemType } from '../../framework/microAppTypes'

type LeftNavProps = {
  leftNavDisplayItems: any
  state: StoreState
  vars: Vars
  oidc: OidcState | undefined
  logo: string | undefined
  collapsedLogo: string | undefined
  activeNavItem: NavItemType | undefined
  activeSubNavItem: NavItemType | undefined
}

const LeftNav: VFC<LeftNavProps> = ({ leftNavDisplayItems, state, vars, oidc, logo, collapsedLogo, activeNavItem, activeSubNavItem }) => {

  const { Navigation } = vars?.use_scm_nav_style_update ? sparkyNav : legacyNav

  const onCollapse = useCallback((collapsed: boolean) => {
    if (stateRef?.current?.isSideNavCollapsed !== collapsed) {
      setValuesInternal({ isSideNavCollapsed: collapsed })
    }
  }, [])

  useEffect(() => {
    const classList = getRootElement()?.classList
    classList?.[state.isSideNavCollapsed ? 'add' : 'remove']('sparky-nav-collapsed')
  }, [state.isSideNavCollapsed])

  return (
    <Navigation
      logo={collapsedLogo || defaultCollapsedLogo}
      logoUrl={'/'}
      fullName={logo || defaultLogo}
      hasCollapseController={true}
      isTwoLines={vars.two_lines_logo || false}
      onCollapseChange={onCollapse}
    >
      <TopNavigation state={state} leftNavDisplayItems={leftNavDisplayItems} activeNavItem={activeNavItem} activeSubNavItem={activeSubNavItem} vars={vars} />
      <BottomNavigation state={state} vars={vars} oidc={oidc} activeNavItem={activeNavItem} activeSubNavItem={activeSubNavItem} />
    </Navigation>
  )
}

export default LeftNav
